<template>
	<slot></slot>
</template>

<script setup>
import { onBeforeUnmount, watch } from '@vue/runtime-core'

const props = defineProps({
	scrollable: {
		type: Boolean,
		default: true
	}
})

const disableScroll = () => document.body.classList.add('overflow-hidden')
const enableScroll = () => document.body.classList.remove('overflow-hidden')

watch(
	() => props.scrollable,
	(scrollable) => {
		scrollable ? enableScroll() : disableScroll()
	},
	{
		immediate: true
	}
)

onBeforeUnmount(enableScroll)
</script>

<style>
.overflow-hidden {
	overflow: hidden !important;
}
</style>
